(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('cart-form');
    if (!form) return;

    const decreaseBtns = form.querySelectorAll('[data-decrease]');
    const increaseBtns = form.querySelectorAll('[data-increase]');

    decreaseBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        const line = this.dataset.line;
        const input = form.querySelector(`input[data-line="${line}"]`);
        const currentValue = parseInt(input.value);
        if (currentValue > 0) {
          input.value = currentValue - 1;
        }
      });
    });

    increaseBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        const line = this.dataset.line;
        const input = form.querySelector(`input[data-line="${line}"]`);
        const currentValue = parseInt(input.value);
        input.value = currentValue + 1;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const countdownEl = document.querySelector('[data-countdown]');
    if (!countdownEl) return;

    const targetDate = new Date(countdownEl.dataset.targetDate).getTime();
    const daysEl = countdownEl.querySelector('[data-days]');
    const hoursEl = countdownEl.querySelector('[data-hours]');
    const minutesEl = countdownEl.querySelector('[data-minutes]');
    const secondsEl = countdownEl.querySelector('[data-seconds]');

    function updateCountdown() {
      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance < 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      daysEl.textContent = String(days).padStart(2, '0');
      hoursEl.textContent = String(hours).padStart(2, '0');
      minutesEl.textContent = String(minutes).padStart(2, '0');
      secondsEl.textContent = String(seconds).padStart(2, '0');
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-group"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const faqGroups = document.querySelectorAll('.faq-group');
    
    faqGroups.forEach(function(group) {
      const details = group.querySelectorAll('.faq-group__item');
      
      details.forEach(function(targetDetail) {
        targetDetail.addEventListener('toggle', function() {
          if (targetDetail.open) {
            details.forEach(function(detail) {
              if (detail !== targetDetail && detail.open) {
                detail.open = false;
              }
            });
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.querySelector('.header');
  const mobileToggle = document.querySelector('.header__mobile-toggle');

  if (mobileToggle) {
    mobileToggle.addEventListener('click', () => {
      const isOpen = header.classList.toggle('header--menu-open');
      mobileToggle.setAttribute('aria-expanded', isOpen);
    });
  }

  const mobileMenuToggles = document.querySelectorAll('[data-menu-toggle]');
  
  mobileMenuToggles.forEach(toggle => {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      const menuItem = toggle.closest('.header__mobile-menu-item');
      const isExpanded = menuItem.classList.toggle('header__mobile-menu-item--expanded');
      toggle.setAttribute('aria-expanded', isExpanded);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('product-form');
    if (!form) return;

    const quantityInput = form.querySelector('#quantity');
    const decreaseBtn = form.querySelector('[data-decrease]');
    const increaseBtn = form.querySelector('[data-increase]');
    const variantInputs = form.querySelectorAll('.product__variant-input');
    const priceValue = document.querySelector('.product__price-value');
    const addToCartBtn = form.querySelector('.product__add-to-cart');

    // Group tickets functionality
    const variantsPillsContainer = form.querySelector('.product__variants-pills');
    if (variantsPillsContainer) {
      const variantPairs = [];
      const inputs = variantsPillsContainer.querySelectorAll('.product__variant-input');
      
      inputs.forEach(input => {
        const label = variantsPillsContainer.querySelector(`label[for="${input.id}"]`);
        if (label) {
          variantPairs.push({ input, label });
        }
      });

      if (variantPairs.length >= 8) {
        const groups = [
          { title: 'Session 1 (11am to 2pm)', items: variantPairs.slice(0, 3) },
          { title: 'Session 2 (4pm to 7pm)', items: variantPairs.slice(3, 6) },
          { title: 'VIP Tickets', items: variantPairs.slice(6, 8) }
        ];

        variantsPillsContainer.innerHTML = '';

        groups.forEach(group => {
          const groupDiv = document.createElement('div');
          groupDiv.className = 'product__variant-group';

          const groupTitle = document.createElement('h3');
          groupTitle.className = 'product__variant-group-title';
          groupTitle.textContent = group.title;
          groupDiv.appendChild(groupTitle);

          const groupItems = document.createElement('div');
          groupItems.className = 'product__variant-group-items';

          group.items.forEach(pair => {
            groupItems.appendChild(pair.input);
            groupItems.appendChild(pair.label);
          });

          groupDiv.appendChild(groupItems);
          variantsPillsContainer.appendChild(groupDiv);
        });
      }
    }

    if (decreaseBtn) {
      decreaseBtn.addEventListener('click', function() {
        const currentValue = parseInt(quantityInput.value);
        if (currentValue > 1) {
          quantityInput.value = currentValue - 1;
        }
      });
    }

    if (increaseBtn) {
      increaseBtn.addEventListener('click', function() {
        const currentValue = parseInt(quantityInput.value);
        quantityInput.value = currentValue + 1;
      });
    }

    variantInputs.forEach(input => {
      input.addEventListener('change', function() {
        const price = this.dataset.price;
        const isAvailable = !this.disabled;
        
        if (priceValue && price) {
          priceValue.textContent = price;
        }

        if (addToCartBtn) {
          if (isAvailable) {
            addToCartBtn.disabled = false;
            addToCartBtn.textContent = addToCartBtn.dataset.addText || 'Add to Cart';
          } else {
            addToCartBtn.disabled = true;
            addToCartBtn.textContent = addToCartBtn.dataset.soldOutText || 'Sold Out';
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-gallery"] && !Shopify.designMode) return;
  try {
    
  class SliderGallery {
    constructor(section) {
      this.section = section;
      this.currentIndex = 0;
      this.mainImages = section.querySelectorAll('.slider-gallery__main-image');
      this.thumbnails = section.querySelectorAll('.slider-gallery__thumbnail');
      this.prevButton = section.querySelector('.slider-gallery__arrow--prev');
      this.nextButton = section.querySelector('.slider-gallery__arrow--next');
      
      this.init();
    }

    init() {
      this.prevButton.addEventListener('click', () => this.navigate(-1));
      this.nextButton.addEventListener('click', () => this.navigate(1));
      
      this.thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', () => this.goToSlide(index));
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.navigate(-1);
        if (e.key === 'ArrowRight') this.navigate(1);
      });
    }

    navigate(direction) {
      const newIndex = this.currentIndex + direction;
      
      if (newIndex < 0) {
        this.goToSlide(this.mainImages.length - 1);
      } else if (newIndex >= this.mainImages.length) {
        this.goToSlide(0);
      } else {
        this.goToSlide(newIndex);
      }
    }

    goToSlide(index) {
      this.mainImages[this.currentIndex].classList.remove('slider-gallery__main-image--active');
      this.thumbnails[this.currentIndex].classList.remove('slider-gallery__thumbnail--active');
      
      this.currentIndex = index;
      
      this.mainImages[this.currentIndex].classList.add('slider-gallery__main-image--active');
      this.thumbnails[this.currentIndex].classList.add('slider-gallery__thumbnail--active');
      
      this.thumbnails[this.currentIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const galleries = document.querySelectorAll('.slider-gallery');
    galleries.forEach(gallery => new SliderGallery(gallery));
  });

  } catch(e) { console.error(e); }
})();
})();
